<template>
  <div>
    <v-dialog v-model="dialog" width="450">
      <template v-slot:activator="{ on }">
        <v-btn class="mt-2" v-on="on" color="red">
          Debaja de ficha ganadera
        </v-btn>
      </template>
      <v-card>
        <v-card-title>Debaja de la ficha ganadera</v-card-title>
        <v-card-subtitle>Acción correctiva</v-card-subtitle>
        <v-card-text class="black--text">
          ¿Desea dar debaja a la ficha ganadera con id:
          <b>{{ fichaGanadera.idFichaGanadera }}</b
          >?
          <p>
            La ficha está asociada a la <b>{{ temporadaFicha.nombre }}</b> y
            tiene asignada una superficie de {{ fichaGanadera.superficie }}ha.
          </p>
          <p>
            Al dar debaja de la ficha, se eliminarán todos los datos asociados a
            ella, como inventarios, movimientos de ganado y movimientos
            financieros.
          </p>
          <p>
            <b>Una vez eliminada esta ficha, no será posible recuperarla.</b>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="error" text @click="debajaFichaGanadera()"
            >Dar debaja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfiguracionRepository from "@/services/ConfiguracionRepository";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "FhDebajaFichaGanadera",
  data: () => ({
    dialog: false,
    saveDisabled: false,
  }),
  methods: {
    ...mapActions("fichas", ["fetchFichaGanadera", "clearFichaGanadera"]),
    ...mapActions("retiros", ["fetchListaRetiros", "clearListaRetiros"]),
    ...mapActions("temporada", ["fetchListaTemporada"]),
    ...mapActions("agricultor", ["fetchListaGrupoExplotacion"]),
    async debajaFichaGanadera() {
      try {
        if (
          !this.saveDisabled &&
          this.fichaGanadera != null &&
          this.fichaGanadera.idFichaGanadera != null
        ) {
          this.saveDisabled = true;
          await ConfiguracionRepository.debajaFicha(
            this.fichaGanadera.idFichaGanadera
          );

          this.dialog = false;
          this.saveDisabled = false;
          this.clearFichaGanadera();
          this.clearListaRetiros();
          await this.fetchListaTemporada();
          this.$router.push({ name: "GanaderiaHome" }).catch(() => {});
        }
      } finally {
        this.saveDisabled = false;
      }
    },
  },
  computed: {
    ...mapState("fichas", ["fichaGanadera", "parcelas"]),
    ...mapState("temporada", [
      "temporada",
      "temporadaActual",
      "listaTemporada",
    ]),
    ...mapGetters("temporada", [
      "isTemporadaSet",
      "getTemporadaAgricultor",
      "filteredListaTemporadaAgricultor",
    ]),
    temporadaFicha() {
      let temp = this.listaTemporada.find(
        (temporada) => temporada.idTemporada == this.fichaGanadera.idTemporada
      );
      return temp !== undefined ? temp : { nombre: "" };
    },
  },
};
</script>

<style>
</style>